const initialState = {
  loading: false,
  oas: [],
  error: '',
  activeOa: {
    seq_cadast: 0,
  },
};

const oas = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_OAS_STARTED':
      return {
        ...state,
        loading: true,
      };
    case 'GET_OAS_SUCCESS':
      return {
        ...state,
        loading: false,
        error: '',
        oas: action.payload,
      };
    case 'GET_OAS_FAIL':
      return {
        ...state,
        loading: false,
        error: action.payload,
        oas: [],
      };
    case 'SET_ACTIVE_OA':
      return {
        ...state,
        activeOa: action.payload,
      };
    case 'CLEAR_ACTIVE_OA':
      return {
        ...state,
        activeOa: action.payload,
      };
    default:
      return state;
  }
};

export default oas;
